import React from "react";

function ContactAboveFooter() {
  return (
    <section  id="contact" className="bg-light pt-5 pb-0">

      {/* CONTACT HEADER */}
      <div className="container text-center mb-5" data-aos="fade-up">
        <h2 className="text-success fw-bold mb-2">Contact Us</h2>
        <p className="text-muted">Get in touch for inquiries or partnership opportunities.</p>
        <p><strong>Email:</strong> d2dgroup.in@gmail.com</p>
      </div>

      {/* BRANCH BOXES */}
      <div className="container mb-5" data-aos="fade-up" data-aos-delay="150">
        <div className="row g-3 text-center">
          {[
            { title: "CHENNAI HEAD OFFICE", phone: "+919442932753" },
            { title: "COIMBATORE BRANCH", phone: "+918124343494" },
            { title: "ELAMPILLAI BRANCH", phone: "+919363034349" },
          ].map((b, i) => (
            <div key={i} className="col-md-4">
              <div className="border rounded p-3 bg-white shadow-sm h-100">
                <h6 className="fw-bold">{b.title}</h6>

                <p className="text-success fw-semibold mb-0">
                  <a href={`tel:${b.phone}`} className="text-success text-decoration-none">
                    {b.phone}
                  </a>
                </p>

              </div>
            </div>
          ))}
        </div>
      </div>



    </section>
  );
}

export default ContactAboveFooter;
